import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DocumentoAllegato } from '../../../common/models/documento-allegato';

import { HelpersService } from '../../../core/services/helpers.service';
import { DocumentManagementStoreService } from '../../services/document-management-store.service';
import { DocumentManagementService } from '../../services/document-management.service';
import { Pagination } from 'src/app/common/models/pagination';

@Component({
  selector: 'app-document-detail-tabs',
  templateUrl: './document-detail-tabs.component.html',
  styleUrls: ['./document-detail-tabs.component.css']
})
export class DocumentDetailTabsComponent implements OnInit {

  @Input() elaborationId: string;

  src;
  pageText$: Observable<string>;

  pagesNumber$: Observable<number>;


  constructor(
    private helpersService: HelpersService,
    private documentManagementService: DocumentManagementService,
    private domSanitizer: DomSanitizer,
    private dMStore: DocumentManagementStoreService
    ) {
  }

  ngOnInit() {
    this.pageText$ = this.dMStore.currentPage$;
    this.pagesNumber$ = this.dMStore.pagesNumber$;
    this.dMStore.changePage(0);
  }

  loadElaboration() {
    if (!this.src) {
      // Mi prendo solo il primo documento perchè a FE viene gestito 1 doc : 1 elaborazione
      this.documentManagementService.getDocuments(this.elaborationId)
        .pipe(map(el => el.documenti[0]))
        .subscribe((doc: DocumentoAllegato) => {
          this.helpersService.getDocumentoByIdDocumentale(doc.refDocumentale, doc.versione).subscribe(res => {
            this.src = this.domSanitizer.bypassSecurityTrustResourceUrl(res);
          })
        })
    }
  }

  changePage(pagination: Pagination){
    this.dMStore.changePage(pagination.getCurrentPage());
  }

}
